// extracted by mini-css-extract-plugin
export default {"editButton":"hrStop_editButton__VmZJE","TableBody":"hrStop_TableBody__vHJ8+","StopButton":"hrStop_StopButton__gp6sO"};